import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Styles } from "./styles/sidebar.js";

function Sidebar() {
    useEffect(() => {
        const sidebarBtn = document.getElementById("sidebar-btn");

        if (sidebarBtn) {
            const sidebarOverlay = document.getElementById("sidebar-overlay");
            const sidebarBody = document.getElementById("sidebar-body");
            const sidebarExit = document.getElementById("close-sidebar");

            sidebarBtn.addEventListener("click", function (e) {
                e.preventDefault();
                sidebarOverlay.classList.add("visible");
                sidebarBody.classList.add("opened");
            });

            sidebarOverlay.addEventListener("click", function (e) {
                e.preventDefault();
                sidebarOverlay.classList.remove("visible");
                sidebarBody.classList.remove("opened");
            });

            sidebarExit.addEventListener("click", function (e) {
                e.preventDefault();
                sidebarOverlay.classList.remove("visible");
                sidebarBody.classList.remove("opened");
            });
        }
    });

    return (
        <Styles>
            {/* Sidebar */}
            <a href="/" className="nav-link nav-sidebar" id="sidebar-btn">
                <i className="las la-bars"></i>
            </a>

            <div className="sidebar" id="sidebar-body">
                <div className="side-logo d-flex justify-content-between">
                    <div>
                        <Link to="/">
                            <img src="/assets/images/logo2.png" alt="" />
                        </Link>
                    </div>
                    <div>
                        <a href="/" id="close-sidebar">
                            <i className="las la-times"></i>
                        </a>
                    </div>
                </div>

                <div className="side-content">
                    <h5>About Us</h5>
                    <p>
                        Care University of Education focuses on academic excellence, skill development, and overall growth. With experienced
                        faculty and a student-centered approach, we prepare learners to succeed in their careers and contribute positively
                        to society.
                    </p>
                </div>

                {/* <div className="side-post">
                    <h5>Recent Post</h5>

                    <div className="post-box d-flex">
                        <div className="post-img">
                            <img src="/assets/images/post-01.jpg" alt="" />
                        </div>
                        <div className="post-title">
                            <p>Lorem ipsum dolor sit amet, consecte adipisicing elit.</p>
                            <span>March 12, 2020</span>
                        </div>
                    </div>

                    <div className="post-box d-flex">
                        <div className="post-img">
                            <img src="/assets/images/post-02.jpg" alt="" />
                        </div>
                        <div className="post-title">
                            <p>Lorem ipsum dolor sit amet, consecte adipisicing elit.</p>
                            <span>March 12, 2020</span>
                        </div>
                    </div>

                    <div className="post-box d-flex">
                        <div className="post-img">
                            <img src="/assets/images/post-03.jpg" alt="" />
                        </div>
                        <div className="post-title">
                            <p>Lorem ipsum dolor sit amet, consecte adipisicing elit.</p>
                            <span>March 12, 2020</span>
                        </div>
                    </div>
                </div> */}

                <div className="side-gallery">
                    <h5>Gallery</h5>
                    <img src="/assets/images/imagegallery-01.png" alt="" />
                    <img src="/assets/images/imagegallery-02.png" alt="" />
                    <img src="/assets/images/imagegallery-03.png" alt="" />
                    <img src="/assets/images/imagegallery-04.png" alt="" />
                    <img src="/assets/images/imagegallery-05.png" alt="" />
                    <img src="/assets/images/imagegallery-06.png" alt="" />
                </div>

                <div className="side-contact">
                    <h5>Contact Us</h5>
                    <ul className="list-unstyled">
                        <li><i className="las la-map-marker"></i>Near Golden Future Library <br />Roorkee 247667</li>
                        <li><i className="las la-phone"></i>+91 7599020021 </li>
                        <li><i className="las la-phone"></i>+91 8791551455 </li>
                        <li><i className="las la-envelope"></i>info@erptechpro.in</li>
                    </ul>
                </div>

                <div className="side-social">
                    <ul className="list-unstyled list-inline">
                        <li className="list-inline-item"><a href="https://www.facebook.com/61580941010197/"><i className="fab fa-facebook-f"></i></a></li>
                        <li className="list-inline-item"><a  href="https://wa.me/917599020021"><i className="fab fa-whatsapp"></i></a></li>
                        <li className="list-inline-item"><a href="https://youtube.com/@erptechpro?si=nhu16ox6xv46Kdx9"><i className="fab fa-youtube"></i></a></li>
                        <li className="list-inline-item"><a href="https://www.instagram.com/erptechproofficial?igsh=MTN2NG9xbmJ0MTY1dg=="><i className="fab fa-instagram"></i></a></li>
                    </ul>
                </div>
            </div>

            <div className="sidebar-overlay" id="sidebar-overlay"></div>
        </Styles>
    )
}

export default Sidebar;